import { useEffect, useState } from "react";

const LINKS = [
  ["podbor", "Подбор"],
  ["rezultat", "Результат"],
  ["metod", "Метод"],
  ["voprosy", "Вопросы"],
];

/* B7: компактная плавающая шапка по центру, полупрозрачная, с blur. Мобильное
   меню открывается на всю высоту, ссылки въезжают по очереди (шаг 60мс, потолок 400мс). */
export const StickyNav = ({ scrollTo }) => {
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-45% 0px -55% 0px" }
    );
    ["podbor", "rezultat", "metod", "voprosy", "form"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) io.observe(el);
    });
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const go = (id) => {
    setOpen(false);
    scrollTo(id);
  };

  const bar = "block h-0.5 w-5 bg-white transition-transform duration-500 ease-smooth";

  return (
    <>
      <header className="fixed inset-x-0 top-4 z-50 flex justify-center px-4" data-testid="sticky-nav">
        <nav
          aria-label="Основная навигация"
          className="glass flex items-center gap-4 rounded-full p-2 sm:gap-6 sm:pl-5"
        >
          <button
            onClick={() => go("hero")}
            className="px-2 font-display text-base font-semibold transition-colors duration-300 ease-smooth hover:text-accent-soft"
            data-testid="nav-home"
          >
            Gride.pro
          </button>

          <div className="hidden items-center gap-6 sm:flex">
            {LINKS.map(([id, label]) => (
              <button
                key={id}
                onClick={() => go(id)}
                aria-current={active === id ? "location" : undefined}
                className={`text-sm transition-colors duration-300 ease-smooth ${
                  active === id ? "text-accent-soft" : "text-muted hover:text-white"
                }`}
                data-testid={`nav-${id}`}
              >
                {label}
              </button>
            ))}
          </div>

          <button onClick={() => go("form")} className="btn btn-sm" data-testid="nav-cta">
            Получить разбор
          </button>

          <button
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? "Закрыть меню" : "Открыть меню"}
            className="flex h-10 w-10 flex-col items-center justify-center gap-1 sm:hidden"
            data-testid="nav-toggle"
          >
            <span className={`${bar} ${open ? "translate-y-1.5 rotate-45" : ""}`} />
            <span className={`${bar} ${open ? "scale-x-0" : ""}`} />
            <span className={`${bar} ${open ? "-translate-y-1.5 -rotate-45" : ""}`} />
          </button>
        </nav>
      </header>

      <div
        id="mobile-menu"
        aria-hidden={!open}
        inert={!open}
        className={`fixed inset-0 z-40 flex flex-col justify-center gap-6 bg-ink-0/95 px-6 backdrop-blur-xl transition-opacity duration-500 ease-smooth sm:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        {LINKS.map(([id, label], i) => (
          <button
            key={id}
            onClick={() => go(id)}
            style={{ transitionDelay: open ? `${Math.min(i * 60, 400)}ms` : "0ms" }}
            className={`text-left font-display text-4xl font-medium transition-[transform,opacity] duration-500 ease-smooth ${
              open ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </>
  );
};
